import WebServiceRequest from '../Api/WebServiceRequest'

class StaticPageCreateRequest extends WebServiceRequest {
    constructor(context) {
        super(context)
        super.setTag('StaticPage/Create')
    }

    setParams(data) {
        super.setRequestParamDataObj(data)
    }
}

class StaticPageUpdateRequest extends WebServiceRequest {
    constructor(context) {
        super(context)
        super.setTag('StaticPage/Update')
    }

    setParams(data) {
        super.setRequestParamDataObj(data)
    }
}

class StaticPageGetByTypeRequest extends WebServiceRequest {
    constructor(context) {
        super(context)
    }

    setType(type) {
        super.setTag('StaticPage/GetByType?type=' + type);
    }
}


class StaticPageCreateById extends WebServiceRequest {
    constructor(context) {
        super(context)
        super.setTag('StaticPage/Create');
    }

    setBody(data) {
        super.setRequestParam(data)
    }
}

class StaticPageGetById extends WebServiceRequest {
    constructor(context) {
        super(context)
        super.setTag('StaticPage/Get');
    }

    setParams(data) {
        super.setRequestParam(data)
    }
}

class StaticPageUpdateById extends WebServiceRequest {
    constructor(context) {
        super(context)
        super.setTag('StaticPage/Update');
    }

    setBody(data) {
        super.setRequestParamDataObj(data)
    }
}


export {
    StaticPageCreateRequest,
    StaticPageUpdateRequest,
    StaticPageGetByTypeRequest,
    StaticPageGetById,
    StaticPageCreateById,
    StaticPageUpdateById,
};